import React from 'react';
import { Card } from 'antd';
import { isCustom } from '@prerender/billing-shared';
import BillingRenderUsage from '../statistics/BillingRenderUsage';
import { Container } from '../../../components/CssFrameworkComponents';
import { BillingOverviewPlan } from './BillingOverviewPlan';
import { BillingOverviewCostEstimate } from './BillingOverviewCostEstimate';
import { BillingOverviewBillingActivity } from './BillingOverviewBillingActivity';
import BillingRenderExpenses from '../statistics/BillingRenderExpenses';
import PriceUpdate2026Banner from './PriceUpdate2026Banner';
import { usePrerenderUser } from '../../../hooks/usePrerenderUser';

const BillingOverview = () => {
  const user = usePrerenderUser();
  const isUserOnCustomPlan = isCustom(user.chargebeePlanId);

  return (
    <Container fluid addClass={'p-0'}>
      <h3 className="">Billing Overview</h3>
      <p className="text-base text-grey">
        Here you'll find information about your subscription, render usage, and costs.
      </p>
      <PriceUpdate2026Banner />
      {isUserOnCustomPlan ? (
        <div className="row">
          <div className="col-12 col-md-12 col-lg-12 col-xl-8 mb-3">
            <Card className="h-100" variant="borderless">
              <BillingOverviewPlan user={user} isUserOnCustomPlan showAccountDetails={true} />
            </Card>
          </div>
          <div className="col-12 col-md-12 col-lg-12 col-xl-4 mb-3">
            <Card className="h-100" variant="borderless">
              <BillingOverviewBillingActivity user={user} />
            </Card>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-12 col-md-12 col-lg-12 col-xl-4 mb-3">
            <Card className="h-100" variant="borderless">
              <BillingOverviewPlan user={user} showAccountDetails={true} />
            </Card>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-4 mb-3">
            <Card className="h-100" variant="borderless">
              <BillingOverviewCostEstimate user={user} />
            </Card>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-4 mb-3">
            <Card className="h-100" variant="borderless">
              <BillingOverviewBillingActivity user={user} />
            </Card>
          </div>
        </div>
      )}
      <h4 className="mt-4" id="render-usage">
        Render Usage
      </h4>
      <p className="text-base text-grey">Below, you'll find your render usage report for the specified time period.</p>
      <div className="row">
        <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-3">
          <Card className="h-100" variant="borderless">
            <BillingRenderUsage />
          </Card>
        </div>
        {!isUserOnCustomPlan ? (
          <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-3">
            <Card className="h-100" variant="borderless">
              <BillingRenderExpenses />
            </Card>
          </div>
        ) : null}
      </div>
    </Container>
  );
};

export default BillingOverview;
